export const getWeekdayNames = (): string[] => {
  const startDate = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1,
  );
  startDate.setDate(startDate.getDate() - startDate.getDay());
  const retVal = [];
  for (let i = 1; i <= 7; i++) {
    startDate.setDate(startDate.getDate() + 1);
    retVal.push(startDate.toLocaleDateString('default', {weekday: 'short'}));
  }
  return retVal;
};
